var predictorTeams = [];
var bannerSlideTimer;
if( $("body").hasClass("venue") ) {
    var player1,
        player2,
        player3,
        player4;
}

$(function(){
    var Leagues = new function(){
        this.init = function()
        {
            //&& $(window).width() >= 768
            if($("#map").length >= 1){
                $("#location-load").show();
                Leagues.setUserLatLng(Leagues.loadVenueMap);
            }
            
            if ($("#choose-country").length > 0) {
                Leagues.chooseCountry();
            }
            
            if ($("#disc-form").length >= 1) Leagues.refDisciplines();
            
            if($(".marquee")) $(".marquee").marquee();
            if($(".join-icons")) Leagues.animateJoinUs();
            $(".custom-select").customSelect();
            
            Leagues.triggerClicks();
            Leagues.handleScroll();
            Leagues.fixturePay();
            Leagues.profilePhoto();
            Leagues.initGallery();
            Leagues.initTeamSlider();
            Leagues.initRefereeSlider();
            Leagues.initTeamWeekSlider();
            Leagues.initNews();
            Leagues.initTooltips();
            Leagues.initPaginateTable();
            Leagues.initOfferButtons();
            Leagues.initMapSearch();
            Leagues.teamPhotos();
            Leagues.ourStory();
            
            if( $("body").hasClass("authed") ) Leagues.getNotifications();
            if( $("body").hasClass("page") && $("body").hasClass("search-fixtures") ) Leagues.searchFixtures();
            if( $("body").hasClass("signup") || $("body").hasClass('captain-request') ) Leagues.signUp();
            if( $("body").hasClass("referee") && $("body").hasClass("signup") ) Leagues.refereeSignup();
            if( $("body").hasClass("change-players-page")) Leagues.changePlayers();
            if( $("body").hasClass("search") ) Leagues.mobileSearch();
            if( $(".banner-item").length >= 1 ) Leagues.siteBanners();
            if( $("body").hasClass("faq") ) Leagues.faqs();
            $('.tooltip').tooltipster();
            $("#webmenu").msDropDown();
            Leagues.handleCoord();
        }
        
        this.searchFixtures = function ()
        {
            var form = $('#fixtures-search-form');
            // var loader = $('.loader', form);
            var leagues_row = $('.wrapper .the-leagues', form);
            var teams_row = $('.wrapper .the-teams', form);
            var divisions_row = $('.wrapper .the-divisions', form);
            var submit_row = $('.wrapper .the-submit', form);
            var leagues_list = $('#leagues-filtered');
            var teams_list = $('#available-teams');
            var divisions_list = $('#available-divisions');
            var league_name = $('#league-name');
            var teamId = $('#teamId');
            var teamUrl = $('#teamUrl');
            var selectLeagueText = $('option', leagues_list)[0].innerHTML;
            var selectTeamText = $('option', teams_list)[0].innerHTML;
            var selectDivisionText = $('option', divisions_list)[0].innerHTML;
            var query = '';
            var leagues_filtered = [];
            var available_teams = [];
            var available_divisions = [];
            var division_teams = [];
            const days = {
                'sunday': {
                    val: 1,
                    short: 'Sun'
                },
                'monday': {
                    val: 2,
                    short: 'Mon'
                },
                'tuesday': {
                    val: 3,
                    short: 'Tues'
                },
                'wednesday': {
                    val: 4,
                    short: 'Weds'
                },
                'thursday': {
                    val: 5,
                    short: 'Thu'
                },
                'friday': {
                    val: 6,
                    short: 'Fri'
                },
                'saturday': {
                    val: 7,
                    short: 'Sat'
                }
            }
            
            if ( league_name.val().length > 2 ) {
                processInput();
            }
            
            $(document).on("change", "select", function () {
                $("option[value=" + this.value + "]", this).attr("selected", true).siblings().removeAttr("selected");
            });
            
            leagues_list.on('change', function () {
                var leagueIndex = parseInt($(this).find(':selected').val().split('-')[1]);
                resetTeams();
                resetDivisions();
                // loader.show();
                available_teams = [];
                divisions_row.hide();
                teams_row.hide();
                submit_row.hide();
                
                if (leagueIndex !== undefined && leagueIndex >= 0) {
                    leagues[leagueIndex].accepted_teams.forEach(function(team) {
                        if (!available_divisions.find(function(div) {return div.id === team.division_id})) {
                            available_divisions.push(team.division);
                        }
                    });
                    available_teams = leagues[leagueIndex].accepted_teams;
                    available_divisions.reverse();
                    assignDivisions();
                }
            });
            
            divisions_list.on('change', function () {
                var divID = $(this).find(':selected').val().split('-')[0];
                
                resetTeams();
                division_teams = [];
                // loader.show();
                teams_row.hide();
                submit_row.hide();
                
                if ( divID !== undefined && parseInt(divID) >= 0 ) {
                    available_teams.forEach(function(team) {
                        if (team.division_id === parseInt(divID)) {
                            division_teams.push(team);
                        }
                    });
                    division_teams.sort(sortByName);
                    assignTeams();
                }
            });
            
            teams_list.on('change', function () {
                var teamData = $(this).find(':selected').val().split('-');
                submit_row.hide();
                
                if ( division_teams[teamData[1]] !== undefined && parseInt(teamData[1]) >= 0 && parseInt(teamData[0]) > 0 ) {
                    teamId.val( parseInt(teamData[0]) );
                    teamUrl.val( division_teams[parseInt(teamData[1])].url );
                    submit_row.show();
                }
            });
            
            if (Object.keys(leagues).length > 0) {
                league_name.on('keyup', function () {
                    processInput();
                });
            }
            
            function processInput () {
                reset();
                resetVisible();
                available_teams = [];
                query = league_name.val();
                const isStringAllowed = /^[a-zA-Z0-9 ]*$/i.test(query);
                if (query.length > 2 && isStringAllowed) {
                    // loader.show();
                    Object.keys(leagues).forEach( function(i) {
                        if ( (new RegExp(query, 'i')).test(leagues[i].name) ) {
                            leagues[i].day = days[leagues[i].playing_day];
                            leagues[i].index = i;
                            leagues_filtered.push(leagues[i]);
                        }
                    });
                    if (leagues_filtered.length > 0) {
                        assignLeagues();
                    }
                }
            }
            
            function sortByName( a, b ) {
                if ( a.name < b.name ){
                    return -1;
                }
                if ( a.name > b.name ){
                    return 1;
                }
                return 0;
            }
            
            function resetVisible() {
                // loader.hide();
                leagues_row.hide();
                teams_row.hide();
                divisions_row.hide();
                submit_row.hide();
            }
            
            function reset () {
                resetTeams();
                resetDivisions();
                resetLeagues();
            }
            
            function resetLeagues () {
                leagues_filtered = [];
                leagues_row.find('.customSelectInner').html(selectLeagueText);
                leagues_list.find('option').remove().end().append('<option value="0" selected="selected">' + selectLeagueText + '</option>').val(0);
            }
            
            function resetDivisions() {
                available_divisions = [];
                divisions_row.find('.customSelectInner').html(selectDivisionText);
                divisions_list.find('option').remove().end().append('<option value="0" selected="selected">' + selectDivisionText + '</option>').val(0);
            }
            
            function resetTeams() {
                teamId.val(0);
                teamUrl.val('');
                teams_row.find('.customSelectInner').html(selectTeamText);
                teams_list.find('option').remove().end().append('<option value="0" selected="selected">' + selectTeamText + '</option>').val(0);
            }
            
            function assignLeagues () {
                leagues_filtered.forEach( function (league) {
                    if (leagues[league.index].accepted_teams.length > 0) {
                        leagues_list.append( new Option( league.name + ' [' + league.day.short + ']', league.id + '-' + league.index ) );
                    }
                });
                leagues_row.show();
                // loader.hide();
            }
            
            function assignDivisions () {
                available_divisions.forEach( function (div, index) {
                    divisions_list.append(new Option(div.name, div.id + '-' + index))
                });
                // loader.hide();
                divisions_row.show();
            }
            
            function assignTeams () {
                division_teams.forEach( function (team, index) {
                    teams_list.append(new Option(team.name, team.id + '-' + index))
                });
                // loader.hide();
                teams_row.show();
            }
        }
        
        this.chooseCountry = function ()
        {
            $(".overlay").on('click', function () {
                $(".overlay").hide();
                $("#choose-country").addClass('hidden');
            });
            
            $("#select-country").on('click', function (e) {
                e.preventDefault();
                
                $(this).toggleClass('open');
                
                return false;
            });
            
            $("#select-country .site").on('click', function (e) {
                if ($(this).data('target')) {
                    window.location.href = $(this).data('target');
                } else {
                    $("#select-country").toggleClass('open');
                }
                
                return false;
            });
            
            $("#choose-country #choose-country-close").on('click', function (e) {
                e.preventDefault();
                
                $(".overlay").hide();
                $("#choose-country").addClass('hidden');
                
                return false;
            });
        }
        
        this.triggerClicks = function()
        {
            var loginData = null;
            
            var globalError = $(".global-error"),
                globalSuccess = $(".global-success");
            
            $(".global-error, .global-success").on('click', function(){
                $(this).fadeOut(500, function(){
                    $(this).remove();
                    
                    if ($("body").hasClass('authed')) {
                        $("body").css('paddingTop', '0px');
                    }
                });
            });
            
            if (globalError.length >= 1 || globalSuccess.length >= 1) {
                
                if ($("body").hasClass('authed')) {
                    $("body").css('paddingTop', '55px');
                }
            }
            
            $('#carousel').slick({
                // centerMode: ($('#carousel').data("players") > 3) ? true : false,
                centerPadding: '20px',
                slidesToShow: 4,
                //autoplay: true,
                autoplaySpeed: 3500,
                arrows: true,
                //variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            // centerMode: ($('#carousel').data("players") > 2) ? true : false,
                            slidesToShow: 1,
                            centerPadding: 0,
                        }
                    }
                ]
            });
            
            $(".trigger-login").on('click', function(e){
                if($(window).width() >= 768){
                    if (!loginData) {
                        $.get('/view/login', function(data){
                            Leagues.loadOverlay(data);
                            loginData = data;
                        });
                    } else {
                        Leagues.loadOverlay(loginData);
                    }
                    
                    e.preventDefault();
                }
            });
            
            $(".confirm").on('click', function(e){
                var msg = $(this).data('delete-msg');
                if (!msg) msg = 'Are you sure you want to do this?';
                
                if (confirm(msg)) {
                    window.location.href = this.href;
                } else {
                    e.preventDefault();
                }
            });

            $(".toggle-menu").on("click", function(e){
                e.preventDefault();
                e.stopPropagation();

                var navToggle = $(this);

                if (navToggle.hasClass('active')) {
                    navToggle.removeClass('active');
                } else {
                
                    $("#nav-toggle, .toggle-menu").removeClass('active');
                    $("#nav-menu").addClass('hidden');
                    
                    // $(".toShow").fadeOut(500);
                    $(".toShow").hide();
                    
                    navToggle.toggleClass("active");
                }
                
                if(navToggle.hasClass('active')){
                    $(".toShow", navToggle.parent()).show();
                } else $(".toShow", navToggle.parent()).hide();

                return false;
            });

            $(".toggle-nav-menu").on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $("#nav-menu").toggleClass('hidden');

                return false;
            });

            $(".toggle-useful-links").on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $("#useful-links").toggleClass('hidden');

                return false;
            });
            
            // $("#nav-toggle").on( "click", function(e){
            //     var navToggle = $("#nav-toggle");
                
            //     navToggle.toggleClass("active");
                
            //     if(navToggle.hasClass('active')){
            //         $("#nav-menu").stop(true,true).fadeIn(500);
            //     } else $("#nav-menu").stop(true,true).fadeOut(500);
                
            //     $(".toggle-menu").removeClass('active');
            //     $(".toShow").hide();
                
                
            //     e.preventDefault();
            // });
            
            // $(".toggle-menu").on("click", function(e){
            //     var navToggle = $(this);
                
            //     $("#nav-toggle").removeClass('active');
            //     $("#nav-menu").hide();
                
            //     $(".toShow").fadeOut(500);
                
            //     navToggle.toggleClass("active");
                
            //     if(navToggle.hasClass('active')){
            //         $(".toShow", navToggle.parent()).stop(true,true).fadeIn(500);
            //     } else $(".toShow", navToggle.parent()).stop(true,true).fadeOut(500);
                
            //     e.preventDefault();
            // });
            
            if ($(".ll-tabs")) {
                $("body").on('click', ".ll-tabs .controls a", function(e){
                    
                    var tabSet 	= $(this).parent().parent().parent(),
                        tab 	= $(this).data('tab');
                    
                    $(".controls li", tabSet).removeClass('active');
                    $(this).parent().addClass('active');
                    
                    $(".item", tabSet).hide();
                    $(".item[data-tab="+tab+"]").show();
                    
                    e.preventDefault();
                });
            }
            
            if ($('.slick')) {
                $('.slick').slick({
                    dots: true,
                    arrows: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    autoplay: false,
                    autoplaySpeed: 6000
                });
            }
            
            if ($('#transfer-market-content')) {
                $('#transfer-market-content').slick({
                    dots: true,
                    arrows: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    responsive: [
                        {
                            breakpoint: 3500,
                            settings: {
                                dots: true,
                                arrows: false,
                                slidesToScroll: 5,
                                slidesToShow: 5,
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                dots: false,
                                arrows: true,
                                slidesToScroll: 3,
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                dots: false,
                                arrows: true,
                                slidesToScroll: 1,
                                slidesToShow: 1,
                            }
                        }]
                });
            }
            
            if ($(".choose-site")) {
                setTimeout( function () {
                    $('.choose-site .slick-track .site img').on( 'click', function () {
                        var classes = $(this).parent().parent().attr('class');
                        if ( classes.includes('slick-current') ) {
                            window.location.href = $(this).data('url');
                        }
                    });
                }, 0);
            }
            
            if ($(".select-day")) {
                $(".select-day").on('click', function(e) {
                    Leagues.selectLeagueDay(this);
                    e.preventDefault();
                });
            }
            
            $("select[name=league_url]").on('change', function() {
                var device = $(this).data('device');
                $(".league-select-form." + device).submit();
            });
            
            $("select.team-quick-switch").on('change', function() {
                var quickSwitch = $("input[name=team_switch_route]").val();
                
                window.location.href = quickSwitch + '/' + $(this).val();
            });
            
            if ($(".sticky-league").length >= 1) {
                $("body").css('paddingBottom', '65px');
            }
            
            if ($(".read-more").length >= 1) {
                setTimeout(function(){
                    Leagues.readMore();
                }, 500);
            }
            
            $("body").on('click', '.quick-division', function(e) {
                var quickUrl = $(this).data('quick-url');
                var scorePredictorUrl = $(this).data('score-predictor-url');
                
                if (quickUrl.length >= 1) {
                    var divisionName = $(this).text();
                    $('.division-name', '.venue-row').text(divisionName);
                    history.replaceState({}, document.title, $(this).attr('href'));
                    
                    Leagues.quickDivision(quickUrl, scorePredictorUrl);
                    
                    setTimeout(function(){
                        Leagues.leagueStatsInfo();
                    }, 500);
                }
                
                e.preventDefault();
            });
            
            if ($(".season-starts")) {
                
                $(".season-starts .animate").hide();
                $(".season-starts .animate:first").show();
                
                Leagues.animateSeason(2, $(".season-starts").data('animate'));
                
                if ($("#season-starts").length >= 1) {
                    var seasonDays = $("#season-starts").data('days');
                    
                    var options = {
                        useEasing : true,
                        useGrouping : true,
                        separator : ',',
                        decimal : '.',
                        prefix : '',
                        suffix : ''
                    };
                    
                    var seasonStarts = new CountUp("season-starts", 0, seasonDays, 0, 5, options);
                    seasonStarts.start();
                }
            }
            
            $(".sticky-close").on('click', function(e) {
                $(".sticky-league").fadeOut();
                e.preventDefault();
            });
            
            $("select[name=league-division_url]").on('change', function(e) {
                var divisionName = $(this).find('option:selected').text();
                $('.division-name', '.venue-row').text(divisionName);
                history.replaceState({}, document.title, $("input[name=league_url]").val() + '/' + $(this).val());
                
                Leagues.quickDivision($("input[name=league-division_redirect]").val() + '/' + $(this).val(), $("input[name=league-score-predictor_url]").val() + '/' + $(this).val());
                e.preventDefault();
                
                setTimeout(function(){
                    Leagues.leagueStatsInfo();
                }, 500);
            });
            
            $(".btn-add-players").on('click', function(e){
                
                var playerCount 	= parseInt($("input[name=player_count]").val()),
                    playerHolder 	= $("#player-list"),
                    lastRow			= $(".player:last", playerHolder),
                    clone 			= lastRow.clone(),
                    newPlayerCount 	= parseInt(playerCount + 1);
                
                $("input[name=player_count]").val(newPlayerCount);
                
                playerHolder.append(clone);
                
                $(".input-group-addon", clone).html(newPlayerCount);
                $(".player_name", clone).attr('name', 'player_name_'+newPlayerCount);
                $(".player_email", clone).attr('name', 'player_email_'+newPlayerCount);
                
                e.preventDefault();
            });
            
            $(".choose-kit").on('click', function(e){
                $(".choose-kit").removeClass('active');
                $(this).addClass('active');
                
                $(".kit-shirt").attr('src', $(this).data('shirt'));
                $(".signup-side-img").attr('src', $(this).data('full'));
                $(".kit-name").html($(this).data('name'));
                
                $("input[name=kit_colour]").val($(this).data('id'));
                
                e.preventDefault();
            });
            
            $("select[name=kit_quantity]").on('change', function(){
                
                $(".total .price").html('<i class="icon-spin icon-spinner"></i>');
                
                var teamId = $(this).data('team-id');
                
                $.getJSON('/team/set_kit_quantity/' + $(this).val() + '/' + teamId, function(data){
                    if(data.price !== null){
                        $(".total .price").html('£'+data.price);
                    }
                });
                
            });
            
            var kitAmount 	= parseInt($(".kit-colours li").length),
                kitWidth	= parseInt($(".kit-colours li:first").outerWidth()),
                kitLength 	= parseInt(kitAmount*kitWidth);
            
            $(".mask").css('width', kitLength+'px');
            
            $(".kit-arrow, .personalise-next").on('click', function(e){
                if($(this).hasClass('personalise') || $(this).hasClass('personalise-next')){
                    var method 			= ($(this).hasClass('prev')) ? 'back' : 'next',
                        shirtNumber		= parseInt($("#view-shirt-number").html()),
                        maxKits 		= $("input[name=kit_quantity]").val();
                    
                    if(method == 'next'){
                        var nextKit 		= parseInt(shirtNumber + 1),
                            currentName 	= $("input[name=kit_player_name_"+shirtNumber+"]"),
                            currentNumber	= $("input[name=kit_player_number_"+shirtNumber+"]");
                        if (nextKit <= maxKits) {
                            if(currentName.val() !== '' || currentNumber.val() !== ''){
                                if(currentName.val().length == 0 || currentNumber.val().length == 0){
                                    alert('Please enter a name and number for shirt #'+shirtNumber);
                                } else {
                                    $("#view-shirt-number").html(nextKit);
                                    
                                    $("#kit_player_name_"+shirtNumber).removeClass('active');
                                    $("#kit_player_number_"+shirtNumber).removeClass('active');
                                    $("#shirt-detail-"+shirtNumber).removeClass('active');
                                    
                                    $("#kit_player_name_"+nextKit).addClass('active');
                                    $("#kit_player_number_"+nextKit).addClass('active');
                                    $("#shirt-detail-"+nextKit).addClass('active');
                                }
                            } else {
                                $("#view-shirt-number").html(nextKit);
                                
                                $("#kit_player_name_"+shirtNumber).removeClass('active');
                                $("#kit_player_number_"+shirtNumber).removeClass('active');
                                $("#shirt-detail-"+shirtNumber).removeClass('active');
                                
                                $("#kit_player_name_"+nextKit).addClass('active');
                                $("#kit_player_number_"+nextKit).addClass('active');
                                $("#shirt-detail-"+nextKit).addClass('active');
                            }
                        } else {
                            $("#personalise-form").submit();
                        }
                        
                    } else {
                        var nextKit 		= parseInt(shirtNumber - 1),
                            currentName 	= $("input[name=kit_player_name_"+shirtNumber+"]"),
                            currentNumber	= $("input[name=kit_player_number_"+shirtNumber+"]");
                        
                        if(nextKit >= 1){
                            $("#view-shirt-number").html(nextKit);
                            
                            $("#kit_player_name_"+shirtNumber).removeClass('active');
                            $("#kit_player_number_"+shirtNumber).removeClass('active');
                            $("#shirt-detail-"+shirtNumber).removeClass('active');
                            
                            $("#kit_player_name_"+nextKit).addClass('active');
                            $("#kit_player_number_"+nextKit).addClass('active');
                            $("#shirt-detail-"+nextKit).addClass('active');
                        } else {
                            e.preventDefault();
                        }
                    }
                    
                } else {
                    var method 			= ($(this).hasClass('prev')) ? 'back' : 'next',
                        maskPos			= $(".mask").css('left').replace('px', ''),
                        visibleAmount	= 3;
                    
                    if(kitWidth == 154 || kitWidth == 126) visibleAmount = 2;
                    
                    if(method == 'next'){
                        move = (maskPos == 'auto') ? move = kitWidth : move = parseInt(maskPos.replace("-","")) + parseInt(kitWidth);
                        
                        if(move <= (kitLength - (kitWidth*visibleAmount))){
                            $(".mask").css('left', '-'+move+'px');
                        }
                    } else {
                        
                        if(maskPos !== 'auto' && maskPos < 0){
                            move = parseInt(maskPos.replace("-","")) - parseInt(kitWidth);
                            
                            $(".mask").css('left', '-'+move+'px');
                        }
                    }
                }
                
                e.preventDefault();
            });
            
            var nameCharacterLength 	= $("input[name=shirt_max_length]").val();
            var numberCharacterLength	= 2;
            
            $(".kit_player_name").on('keyup', function(){
                var element = $(this).attr('name');
                var name 	= $(this).val().replace(/[^a-z 0-9]/gi,'').toUpperCase();
                $(this).val(name);
                
                if(name.length > nameCharacterLength){
                    alert('Please note your name can only be ' + nameCharacterLength + ' or less characters.');
                } else {
                    $("#"+element).html(name);
                }
            });
            
            $(".kit_player_number").on('keyup', function(){
                var element = $(this).attr('name');
                var number 	= $(this).val().replace(/[^0-9]/gi,'');
                $(this).val(number);
                
                if(number.length > numberCharacterLength){
                    alert('Please note your number can only be ' + numberCharacterLength + ' or less characters.');
                } else {
                    $("#"+element).html(number);
                }
            });
            
            $(".coming-soon-form .form").on('submit', function(event) {
                
                $(".coming-soon-form input").removeClass('error');
                
                $.post('/county/coming-soon', $(this).serialize(), function (data) {
                    if (data.status == 'error') {
                        $.each(data.errors, function(field, error) {
                            $("input[name=" + field + "]").addClass('error');
                        });
                    } else {
                        $(".coming-soon-form .form").trigger('reset');
                        $(".cs-message").addClass('hidden');
                        $(".cs-confirm").removeClass('hidden');
                    }
                });
                
                event.preventDefault();
                return false;
            });
            
            $(".coming-soon-trigger").on('click', function() {
                var interestId = $(this).attr('data-id');
                
                if (interestId) {
                    $("input[name=interest_league_id]").val(interestId);
                    
                    $(".coming-soon").removeClass('hidden');
                }
            });
            
            $(".coming-soon .overlay, .coming-soon-close").on('click', function() {
                $(".coming-soon").addClass('hidden');
                $(".coming-soon-form .form").trigger('reset');
                $(".cs-message").removeClass('hidden');
                $(".cs-confirm").addClass('hidden');
            });
            
            $(".settings .drop > a").on('click', function (e) {
                e.preventDefault();
                
                $("ul", $(this).parent()).toggleClass('hidden');
                
                return false;
            });
        }
        
        this.quickDivision = function(url, scorePredictorUrl)
        {
            if (url.length >= 1) {
                $(".quick-division").removeClass('active');
                $(this).addClass('active');
                
                $.getJSON(url, function(data) {
                    
                    if(data.isLastSeason == 0) {
                        $(".table-holder .item[data-tab=table]").html(data.table);
                        $(".f-r-tabs").html(data.fixtureTabs);
                        
                        if (data.lastTable !== null) {
                            $(".table-holder .item[data-tab=lastTable]").html(data.lastTable);
                        }
                        
                        $(".ll-tabs a[data-tab=table]").trigger('click');
                    } else {
                        $("#last-season-only .item[data-tab=lastTable]").html(data.lastTable);
                    }
                });
                
                if (scorePredictorUrl.length >= 1) {
                    $.getJSON(scorePredictorUrl, function(data) {
                        if (data.code === 200 && data.teams) {
                            var predictorTeamsDropDown = $('#predictor-home, #predictor-away', '#scorePredictor .predictor-body').empty();
                            var homePredictedScore = $('#homePredictedScore', '#scorePredictor .predictor-body');
                            var homeKit = $('.predictor-kit img', '#scorePredictor .predictor-body .predictor-home');
                            var awayPredictedScore = $('#awayPredictedScore', '#scorePredictor .predictor-body');
                            var awayKit = $('.predictor-kit img', '#scorePredictor .predictor-body .predictor-away');
                            var teams = data.teams;
                            
                            for (var i = 0; i < teams.length; i++) {
                                if (i === 0) {
                                    homePredictedScore.text(teams[i].predictedScore);
                                    homeKit.attr('src', '/' + teams[i].shirt_image);
                                    awayPredictedScore.text(teams[teams.length > 1 ? i + 1 : i].predictedScore);
                                    awayKit.attr('src', '/' + teams[teams.length > 1 ? i + 1 : i].shirt_image);
                                }
                                
                                // Add teams to the list.
                                if (!(teams[i].id in predictorTeams)) {
                                    predictorTeams[teams[i].id] = {
                                        name: teams[i].name,
                                        predictedScore: teams[i].predictedScore,
                                        shirt_image: teams[i].shirt_image
                                    };
                                }
                                
                                // Generate new dropdown options.
                                predictorTeamsDropDown.append($('<option>', {
                                    value: teams[i].id,
                                    text: teams[i].name
                                }));
                            }
                            
                            $('#predictor-away', '#scorePredictor .predictor-body').val(teams[teams.length > 1 ? 1 : 0].id);
                        }
                    });
                }
            }
        }
        
        this.animateSeason = function(stage, max)
        {
            if (stage <= max) {
                $(".season-starts .animate:nth-child(" + stage + ")").fadeIn();
                
                setTimeout(function() {
                    Leagues.animateSeason((stage + 1), max);
                }, 750);
            }
        }
        
        this.teamPhotos = function()
        {
            $(".edit-team select[name=kit_id]").on('change', function(e) {
                var showImg = $(this).find(':selected').data('image');
                
                if (showImg.length >= 1) {
                    $(".team-kit img.src").attr('src', showImg);
                }
                
                e.preventDefault();
            });
            
            $(".team-upload-photo").on('click', function(e){
                $("input[name=photo].hidden").trigger('click');
                e.preventDefault();
            });
            
            $("input[name=photo]").change(function(e){
                var filename = $(this).val().replace(/C:\\fakepath\\/i, '');
                if(filename){
                    $(".team-photo-result").css('visibility', 'visible').removeClass('text-danger').addClass('text-success').html('Image uploading... <i class="icon icon-spin icon-spinner"></i>').offset();
                    
                    files = e.target.files;
                    
                    //stop defaults happening
                    e.stopPropagation();
                    e.preventDefault();
                    
                    var data = new FormData();
                    $.each(files, function(key, value) {
                        data.append(key, value);
                    });
                    
                    data.append('_token', $("input[name=_token]").val());
                    
                    $.ajax({
                        url: '/team/upload-photo/' + $(this).data('id'),
                        type: 'POST',
                        data: data,
                        cache: false,
                        dataType: 'json',
                        processData: false, // Don't process the files
                        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
                        success: function(data, textStatus, jqXHR)
                        {
                            if (data.status == 'error') {
                                $(".team-photo-result").css('visibility', 'visible').removeClass('text-success').addClass('text-danger').html(data.error);
                            } else if(data.status == 'ok') {
                                $(".team-photo-result").css('visibility', 'visible').removeClass('text-danger').addClass('text-success').html(data.message);
                                $(".team-image img").attr('src', '/' + data.path);
                            }
                        }
                    });
                    
                } else {
                    $(".team-photo-result").css('visibility', 'visible').removeClass('text-danger').addClass('text-success').html('');
                }
            });
            
        }
        
        this.changePlayers = function()
        {
            $(".add-find-player").on('submit', function(e)
            {
                $(".return-error").addClass('hidden').html('');
                $(".return-success").addClass('hidden').html('');
                
                $.post($(this).attr('action'), $(this).serialize(), function(data) {
                    if (data.status == 'error') {
                        $(".return-error").removeClass('hidden').html(data.errorMsg);
                    } else if(data.status == 'ok') {
                        $("input[name=email]").val('');
                        $(".return-error").addClass('hidden');
                        $(".return-success").removeClass('hidden').html(data.successMsg);
                    } else if (data.status == 'invited') {
                        $(".add-players").addClass('hidden');
                        $(".add-players-result .result-text").html(data.successMsg);
                        $(".add-players-result .player-card-box").html(data.card);
                        $(".add-players-result").removeClass('hidden');
                    }
                }, "json");
                
                e.preventDefault();
            });
            
            $("body").on('click', '.close-transfer-invite', function(e) {
                $(".add-players").removeClass('hidden');
                $(".add-players-result").addClass('hidden');
                e.preventDefault();
            });
        }
        
        this.loadOverlay = function(data)
        {
            var body = $("body");
            body.append('<div class="overlay"></div>');
            body.append('<div class="login-float">'+data+'</div>');
            
            $(".login-float").css('left', ($(window).width() - $('.login-float').outerWidth())/2);
            
            $(".overlay").on('click', function(e){
                $(".overlay, .login-float").remove();
                e.preventDefault();
            });
        }
        
        this.getWindowWidth = function()
        {
            var myWidth = 0;
            if( typeof( window.innerWidth ) == 'number' ) {
                //Non-IE
                myWidth = window.innerWidth;
            } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
                //IE 6+ in 'standards compliant mode'
                myWidth = document.documentElement.clientWidth;
            } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
                //IE 4 compatible
                myWidth = document.body.clientWidth;
            }
            
            return myWidth;
        }
        
        this.handleScroll = function()
        {
            setTimeout(function(){
                var scrollPos 		= $(window).scrollTop(),
                    userBarAnimated	= false,
                    footerPos 	= $("footer").offset(),
                    imagePos	= $(".signup-side-img").offset();
                
                Leagues.handleUserBar(scrollPos,userBarAnimated);
                Leagues.handleSignupScroll(scrollPos, imagePos, footerPos)
                
                $(window).on('scroll', function(){
                    var scrollPos 		= $(window).scrollTop();
                    
                    Leagues.handleUserBar(scrollPos,userBarAnimated);
                    Leagues.handleSignupScroll(scrollPos, imagePos, footerPos);
                });
                
                $(window).on('resize', function(){
                    var scrollPos 		= $(window).scrollTop();
                    
                    Leagues.handleUserBar(scrollPos,userBarAnimated);
                });
            }, 200);

            $(window).on('scroll', function(event){
                var bodyScrolled = $(document).scrollTop();
                var windowWidth = $(window).width();
                let scrollPoint;
                
                if (windowWidth >= 992) {
                    scrollPoint = 105;
                } else {
                    scrollPoint = 65;
                }

                if (bodyScrolled > scrollPoint) {
                    if ( !$("body").hasClass('scrolling') ) {
                        $("body").addClass('scrolling');
                    }
                } else if(bodyScrolled < scrollPoint) {
                    if ( $("body").hasClass('scrolling') ) {
                        $("body").removeClass('scrolling');
                    }
                }
            });

            $("#footer-v2").bind('inview', function(event, visible){
                var windowWidth = $(window).width();

                if (visible) {
                    $("#help-footer").hide();

                    $(".sticky-league").css('bottom', '0px');
                } else {
                    $("#help-footer").show();

                    if (windowWidth <= 767) {
                        $(".sticky-league").css('bottom', '55px');
                    } else {
                        $(".sticky-league").css('bottom', '75px');
                    }
                }
            });
        }
        
        this.handleUserBar = function(scrollPos,userBarAnimated)
        {
            var userBar = $("#user-bar");
            
            if($(window).width() > 1023){
                if(scrollPos >= 125){
                    if(!userBarAnimated && !userBar.hasClass("fixed")){
                        userBarAnimated = true;
                        
                        userBar.css('display','block').css('opacity', '1');
                        $(".main-menu #pay-games-big-btn").css('display', 'none');
                    }
                } else {
                    if(!userBar.hasClass("fixed")) userBar.css('opacity', '0').css('display','none');
                    $(".main-menu #pay-games-big-btn").css('display', 'inline-block');
                }
            } else {
                userBar.css('display','block').css('opacity', '1');
            }
        }
        
        this.handleSignupScroll = function(position, imagePos, footerPos)
        {
            if(position && imagePos && footerPos && $(".signup-side-img")){
                var imageHeight = $(".signup-side-img").css('height'),
                    position 		= parseInt(position  + 55), // scrolling user bar
                    positionWithImg = (parseInt(position + 55) + parseInt(imageHeight.replace("px",""))); //when the image is on the footer
                
                if(position > imagePos.top && positionWithImg <= footerPos.top){
                    $(".signup-side-img").css('marginTop', (position - imagePos.top+'px'));
                } else {
                    if(position <= 156) $(".signup-side-img").css('marginTop', '0');
                }
            }
        }
        
        var notify = null;
        
        this.getNotifications = function()
        {
            
            if (location.protocol === 'https:') {
                $.getJSON('/notifications/get/all', function(data) {
                    if (data.status == 'ok' || data.status == 'empty') {
                        if (data.html) {
                            $("#notifications ul").html(data.html);
                            
                            if (data.notifyCount == '0') {
                                $("#notify-count").html('0').hide();
                            } else {
                                $("#notify-count").html(data.notifyCount).show();
                            }
                        }
                    }
                });
                
                notify = setTimeout(function(){
                    Leagues.getNotifications();
                }, 10000);
            }
            
            $("body").on("click", ".mark-all-read", function(e){
                
                $.getJSON($(this).attr('href'), function(data) {
                    if (data.status == 'ok') {
                        $("#notify-count").html('0').hide();
                        
                        $(".mark-all-read").html('Mark all as read <i class="icon-check"></i>');
                    }
                });
                
                e.preventDefault();
            });
        }
        
        this.faqs = function()
        {
            $("dl.questions dt a").on('click', function(e) {
                
                $("dl.questions dt, dl.questions dd").removeClass('active');
                
                $(this).parent().toggleClass('active');
                $(this).parent().next().toggleClass('active');
                e.preventDefault();
            });
            
            $("dl.questions .answer-close").on('click', function(e) {
                $(this).parent().toggleClass('active');
                $(this).parent().prev().toggleClass('active');
                e.preventDefault();
            });
            
            $(".choose-cat").on('change', function(){
                window.location.href = '/faqs/' + $(this).val();
            });
        }
        
        this.mobileSearch = function()
        {
            var bodyScrolled = $(document).scrollTop();
            
            if ($(window).width() <= 768 && bodyScrolled <= 50) {
                if ( undefined !== $("#available").offset() ) {
                    $('html,body').animate({
                        scrollTop: ($("#available").offset().top - 60)
                    });
                }
            }
            
            $("#mobile-league-select .league-days-dd").on('click', function(e){
                
                var par = $(this).parent(),
                    dd = $("ul", par);
                
                if (dd.css('display') == 'none') {
                    dd.show();
                } else {
                    dd.hide();
                }
                
                e.preventDefault();
            });
        }
        
        this.changeGalleryImg = function(img)
        {
            var img = $(img),
                largeImg = img.attr('href');
            
            $(".gallery-main-img").attr('src', largeImg);
        }
        
        
        this.initRefereeSlider = function()
        {
            var currentIndex = 0;
            var animating = false;
            var $parent = $('.referee-slider__image').first();
            var $slider = $('.referee-slider__slides').first();
            var $nav = $('.referee-slider__button');
            var $allImages = $('.referee-slider__slides img');
            var $hoover = $('.referee-slider__hover');
            var totalReferees = $allImages.length;
            var parentWidth = 0;
            
            var handleResize = function () {
                parentWidth = $parent.width();
                
                $allImages.width(parentWidth);
            };
            var moveSlider = function (direction) {
                if (animating) {
                    return;
                }
                
                animating = true;
                
                currentIndex += direction;
                
                if (currentIndex >= totalReferees) {
                    currentIndex = 0;
                }
                
                if (currentIndex < 0) {
                    currentIndex = (totalReferees - 1);
                }
                
                var $find = $('.referee-slider__slides img.slide-' + currentIndex);
                var name = $find.data('name');
                
                $hoover.html(name);
                
                $slider.animate({
                    marginLeft: -(parentWidth * currentIndex),
                }, function () {
                    animating = false;
                });
            };
            
            $nav.on('click', function (e) {
                var direction = parseInt($(this).data('direction'));
                
                moveSlider(direction);
            });
            
            $(window).on('resize', handleResize);
            handleResize();
            moveSlider(0);
        }
        
        this.initMapSearch = function()
        {
            var $search = $('.map-search');
            
            if ($search.length) {
                var $close = $search.find('.map-search__header-button');
                
                $close.click(function (e) {
                    $search.fadeOut();
                    
                    e.preventDefault();
                });
            }
        }
        
        this.initOfferButtons = function()
        {
            var $buttons = $('.js-offer-button');
            var state = true;
            var change = function () {
                var text = 'Join Now';
                var cls = 'spaces-bg';
                var currentClass = state ? 'spaces-bg' : 'special-offer-bg';
                
                if (state) {
                    text = 'Offer';
                    cls = 'special-offer-bg';
                }
                
                state = !state;
                
                $buttons.html(text);
                $buttons.removeClass(currentClass);
                $buttons.addClass(cls);
            };
            
            setInterval(change, 1000);
        }
        
        this.initPaginateTable = function()
        {
            var $tables = $('.table-paginate');
            
            $tables.each(function () {
                $(this).find('.referee-name-actions__item').click(function (e) {
                    var $action = $(this);
                    var $table = $action.closest('.table-paginate').first();
                    var $pageCounter = $table.find('span.current-page');
                    var index = parseInt($table.data('index'));
                    var direction = parseInt($action.data('direction'));
                    var totalPages = $table.find('tbody').length;
                    
                    index += direction;
                    
                    if (index < 0) {
                        index = (totalPages - 1);
                    }
                    
                    if (index >= totalPages) {
                        index = 0;
                    }
                    
                    $table.find('tbody').hide();
                    $table.find('tbody.table-body-' + index).show();
                    $table.data('index', index);
                    $pageCounter.html(index + 1);
                    
                    e.preventDefault();
                });
            });
        }
        
        this.initTooltips = function()
        {
            var $tooltips = $('.js-tooltip');
            
            $tooltips.each(function () {
                var $tooltip = $(this);
                
                if (!$tooltip.data('tooltip-id')) {
                    var id = Math.floor(Math.random() * 2000000);
                    var tooltip = $tooltip.data('tooltip');
                    
                    $tooltip.data('tooltip-id', id);
                    $tooltip.append('<div class="site-tooltip">' + tooltip + '</div>');
                }
            });
        }
        
        this.initNews = function()
        {
            var $select = $('.blog-header-filter__select').first();
            
            if ($select.length) {
                $select.change(function () {
                    var categorySlug = $select.val();
                    
                    if (categorySlug.length) {
                        window.location = '/news/category/' + categorySlug + '/';
                    } else {
                        window.location = '/news/';
                    }
                });
            }
        }
        
        this.initTeamWeekSlider = function()
        {
            var currentIndex = 0;
            var animating = false;
            var singleWidth = 165;
            var singleMargin = 8;
            var $parent = $('.team-week__content').first();
            var $inner = $('.team-week__inner').first();
            var $slider = $('.team-week__slider').first();
            var $nav = $('.team-week-info__button');
            var totalTeams = $('.team-week-player').length;
            var canSee = 0;
            
            var handleResize = function () {
                var parentWidth = $parent.width();
                canSee = Math.floor(parentWidth / singleWidth);
                var newWidth = (canSee * singleWidth) + ((canSee - 1) * singleMargin);
                
                $inner.width(newWidth);
            };
            
            $nav.on('click', function (e) {
                if (animating) {
                    return;
                }
                
                animating = true;
                
                var direction = parseInt($(this).data('direction'));
                var maxIndex = totalTeams - canSee;
                
                currentIndex += direction;
                
                if (currentIndex > maxIndex) {
                    currentIndex = 0;
                }
                
                if (currentIndex < 0) {
                    currentIndex = maxIndex;
                }
                
                $slider.animate({
                    marginLeft: -((currentIndex * singleWidth) + (currentIndex * singleMargin)),
                }, function () {
                    animating = false;
                });
            });
            
            $(window).on('resize', handleResize);
            handleResize();
        }
        
        this.initTeamSlider = function()
        {
            var currentIndex = 0;
            var animating = false;
            var singleWidth = 144;
            var singleMargin = 12;
            var $parent = $('.available-teams').first();
            var $inner = $('.available-teams__inner').first();
            var $slider = $('.available-teams__slider').first();
            var $nav = $('.available-teams-nav__button');
            var totalTeams = $('.available-teams-team').length;
            var canSee = 0;
            
            var handleResize = function () {
                var parentWidth = $parent.width();
                canSee = Math.floor(parentWidth / singleWidth);
                var newWidth = (canSee * singleWidth) + ((canSee - 1) * singleMargin);
                
                $inner.width(newWidth);
            };
            
            $nav.on('click', function (e) {
                if (animating) {
                    return;
                }
                
                animating = true;
                
                var direction = parseInt($(this).data('direction'));
                var maxIndex = totalTeams - canSee;
                
                currentIndex += direction;
                
                if (currentIndex > maxIndex) {
                    currentIndex = 0;
                }
                
                if (currentIndex < 0) {
                    currentIndex = maxIndex;
                }
                
                $slider.animate({
                    marginLeft: -((currentIndex * singleWidth) + (currentIndex * singleMargin)),
                }, function () {
                    animating = false;
                });
            });
            
            $(window).on('resize', handleResize);
            handleResize();
        }
        
        this.initGallery = function()
        {
            var animating = false;
            var currentIndex = 0;
            var currentWidth = 0;
            var currentMargin = 0;
            var currentOffset = 0;
            var $navigation = $('.gallery-navigation .gallery-navigation-left, .gallery-navigation .gallery-navigation-right');
            var $galleryThumbnails = $('.gallery-thumbs');
            var $galleryThumbnailsInner = $('.gallery-thumbs .gallery-thumbs-inner');
            var $thumbnails = $galleryThumbnails.find('a');
            var totalThumbnails = $thumbnails.length;
            var $showGallery = $('.gallery-show-gallery');
            var $showVideo = $('.gallery-show-video');
            var boxesToShow = 5;
            var margin = 4; // %
            var player = true;
            if ($galleryThumbnails.length) {
                var containerScrollWidth = $galleryThumbnails[0].scrollWidth;
            }
            
            var handleResize = function () {
                var containerWidth = $galleryThumbnails.width();
                var totalSpacing = containerWidth * (((boxesToShow - 1) * margin) / 100);
                var spacing = totalSpacing / (boxesToShow - 1);
                var newPercent = (100 / boxesToShow);
                var newWidth = (containerWidth * (newPercent / 100)) - (totalSpacing / boxesToShow);
                
                currentWidth = newWidth;
                currentMargin = spacing;
                
                $thumbnails.css({
                    width: newWidth,
                    paddingTop: (newWidth - 6),
                    marginLeft: spacing,
                });
                
                if ($galleryThumbnails.length) {
                    containerScrollWidth = $galleryThumbnails[0].scrollWidth;
                }
                
                if ( !player ) {
                    $('.gallery-navigation').css({
                        bottom: $galleryThumbnails.outerHeight(),
                        marginBottom: 0
                    });
                }
            };
            var gotoSlide = function(index) {
                if (animating) {
                    return;
                }
                
                if (index < 0) {
                    index = totalThumbnails - 1;
                }
                
                if (index >= totalThumbnails) {
                    index = 0;
                }
                
                animating = true;
                
                var $el = $('.gallery-thumbs a.slide-' + index).first();
                
                $thumbnails.removeClass('active');
                $el.addClass('active');
                
                Leagues.changeGalleryImg($el);
                
                currentIndex = index;
                
                if (true) {
                    var moveTo = currentIndex * (currentWidth + currentMargin);
                    $galleryThumbnailsInner.animate({
                        marginLeft: containerScrollWidth - moveTo >= $galleryThumbnails.outerWidth() ? -moveTo : -(containerScrollWidth - $galleryThumbnails.outerWidth() - currentMargin),
                    }, function() {
                        animating = false;
                    });
                    currentOffset = currentIndex;
                } else {
                    animating = false;
                }
            };
            
            $navigation.on('click', function(e) {
                var direction = parseInt($(this).data('direction'));
                var index = currentIndex + direction;
                
                gotoSlide(index);
                
                e.preventDefault();
            });
            
            $thumbnails.on('click', function(e) {
                var index = parseInt($(this).data('index'));
                
                gotoSlide(index);
                
                e.preventDefault();
            });
            
            $thumbnails.first().addClass('active');
            
            $showGallery.on('click', function(e) {
                player = false;
                
                $('.venue-gallery, .gallery-navigation-left, .gallery-navigation-right').css('display', 'block');
                $('#player1, #player2, #player3, #player4').css('display', 'none');
                
                handleResize();
                
                if (player1) player1.stopVideo();
                if (player2) player2.stopVideo();
                if (player3) player3.stopVideo();
                if (player4) player4.stopVideo();
                
                gotoSlide(0);
                
                e.preventDefault();
            });
            
            $showVideo.on('click', function(e) {
                var videoId = $(this).data('video'),
                    playerId = $(this).data('player'),
                    $player = $('#' + playerId),
                    playerHeight = 0;
                
                player = true;
                
                switch(playerId) {
                    case 'player1':
                        playerHeight = 300;
                        break;
                    case 'player3':
                        playerHeight = 486;
                }
                
                $('.venue-gallery, .gallery-navigation-left, .gallery-navigation-right').css('display', 'none');
                $('.gallery-navigation').css({
                    bottom: '50%',
                    marginBottom: '-62px'
                });
                $player.css('display', 'block');
                
                eval(playerId).loadVideoById(videoId);
                eval(playerId).setSize("100%", playerHeight);
                
                e.preventDefault();
            });
            
            $(window).on('resize', handleResize);
            handleResize();
        }
        
        this.profilePhoto = function()
        {
            $(".captain-upload-photo").on('click', function(e){
                $("input[name=captain_photo].hidden").trigger('click');
                e.preventDefault();
            });
            
            $("#no-photo").on('click', function(e){
                $.get('/player/remove-photo', function(data) {
                    if (data.status == 'ok') {
                        $(".captain-photo-result").css('visibility', 'hidden').html('');
                        $("#captain-photo").removeAttr('style');
                    }
                }, "JSON");
                
                e.preventDefault();
            });
            
            $("input[name=captain_photo]").change(function(e){
                var filename = $(this).val().replace(/C:\\fakepath\\/i, '');
                if(filename){
                    $(".captain-photo-result").css('visibility', 'visible').removeClass('text-danger').addClass('text-success').html('Image uploading... <i class="icon icon-spin icon-spinner"></i>').offset();
                    
                    files = e.target.files;
                    
                    //stop defaults happening
                    e.stopPropagation();
                    e.preventDefault();
                    
                    var data = new FormData();
                    $.each(files, function(key, value) {
                        data.append(key, value);
                    });
                    
                    data.append('_token', $("input[name=_token]").val());
                    
                    $.ajax({
                        url: '/player/upload-photo',
                        type: 'POST',
                        data: data,
                        cache: false,
                        dataType: 'json',
                        processData: false, // Don't process the files
                        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
                        success: function(data, textStatus, jqXHR)
                        {
                            if (data.status == 'error') {
                                $(".captain-photo-result").css('visibility', 'visible').removeClass('text-success').addClass('text-danger').html(data.error);
                            } else if(data.status == 'ok') {
                                $(".captain-photo-result").css('visibility', 'visible').removeClass('text-danger').addClass('text-success').html(data.message);
                                $("#captain-photo").css('backgroundImage', 'url(/' + data.path + ')');
                            }
                        }
                    });
                    
                } else {
                    $(".captain-photo-result").css('visibility', 'hidden').html('');
                }
            });
        }
        
        this.signUp = function()
        {
            if ($("input[name=referee_postcode]")) {
                var prefix = 'referee_';
            } else {
                var prefix = 'captain_';
            }
            
            $(".find-address").on('click', function(e) {
                var postcode = $(".postcode").val();
                
                if (postcode.length <= 1) {
                    postcode = 'null';
                }
                
                $.getJSON('/get-address/' + postcode, function(data) {
                    if (data.status == 'ok') {
                        $(".pc-search").removeClass('text-danger').html('<label>Please Select Address</label>' + data.data);
                    } else {
                        $(".pc-search").addClass('text-danger').html('<p>' + data.message + '</p>');
                    }
                })
                 .fail(function( jqxhr, textStatus, error ) {
                     var err = textStatus + ", " + error;
                     console.log( "Request Failed: " + err );
                 });
                
                e.preventDefault();
            });
            
            $("body").on('change', '.countryId', function(e) {
                var countryId = $(this).val();
                
                if (countryId) {
                    $.getJSON('/get-full-address/' + countryId, function(data) {
                        if (data.status == 'ok') {
                            
                            if ($("input[name=referee_postcode]").length >= 1) {
                                var prefix = 'referee_';
                            } else {
                                var prefix = 'captain_';
                            }
                            
                            $.each(data.address, function(i, el) {
                                $("input[name=" + prefix + i + "]").val(el);
                            });
                        }
                    });
                }
                
                e.preventDefault();
            });
            
            var getAddressDisabled = false;
            
            $("#get-captains-address").on('click', function(e){
                
                if(!getAddressDisabled){
                    getAddressDisabled = true;
                    
                    $("#get-captains-address").append('<i class="icon-spin icon-spinner"></i>');
                    
                    $.getJSON('/league/get_captains_address', function(data){
                        if(data){
                            $.each(data, function(key,val){
                                $("input[name="+key+"],select[name="+key+"]").val(val);
                            });
                        }
                        
                        $("#get-captains-address i").remove();
                        getAddressDisabled = false;
                    });
                }
                
                e.preventDefault();
            });
        }
        
        this.selectLeagueDay = function(el)
        {
            var el = $(el),
                box = $(".select-day-" + el.data('id'));
            
            if (!box.is(":checked")) {
                // not checked....
                el.addClass('active');
                box.attr('checked', 'checked');
            } else {
                el.removeClass('active');
                box.attr('checked', false);
            }
        }
        
        this.setUserLatLng = function(callback)
        {
            if($("#map-location").length >= 1){
                var location = $("#map-location").html();
                if(location){
                    location = JSON.parse(location);
                    
                    if(location) Leagues.loadVenueMap(location, true);
                } else if(navigator.geolocation) navigator.geolocation.getCurrentPosition(callback, Leagues.errorDetected);
            } else {
                if(navigator.geolocation) navigator.geolocation.getCurrentPosition(callback, Leagues.errorDetected);
            }
        }
        
        this.errorDetected = function(error)
        {
            switch(error.code) {
                
                case error.PERMISSION_DENIED:
                    var notFoundLocation = leagueTrans.locationNotFound ? leagueTrans.locationNotFound : "We cannot detect your location. Please enable location, allow in your browser or use the postcode search.";
                    $("#location-load span").html(notFoundLocation);
                    break;
                case error.POSITION_UNAVAILABLE:
                    var noLocationInfo = leagueTrans.locationNoInfo ? leagueTrans.locationNoInfo : "Location information is unavailable.";
                    $("#location-load span").html(noLocationInfo);
                    break;
                case error.TIMEOUT:
                    var locationTimeout = leagueTrans.timeout ? leagueTrans.timeout : "The request to get user location timed out.";
                    $("#location-load span").html(locationTimeout);
                    break;
                case error.UNKNOWN_ERROR:
                    var locationUnknownError = leagueTrans.unknownError ? leagueTrans.unknownError : "An unknown error occurred.";
                    $("#location-load span").html(locationUnknownError);
                    break;
            }
            
            $("#location-load i").remove();
            $("#home-map").remove();
        }
        
        this.loadVenueMap = function(position, auto)
        {
            var siteDivID = $('#5aside-map-controller').val();
            if (siteDivID) {
                var defaultLatLng   = new google.maps.LatLng(52.280999, -1.465852), // default position
                    markerImage     = {
                        url: '/img/5aside-venue-marker.png',
                        scaledSize: new google.maps.Size(45, 50)
                    },
                    personMarkerImage   = {
                        url: '/img/5aside-person-marker.png',
                        scaledSize: new google.maps.Size(51, 57)
                    },
                    mapDiv          = document.getElementById('map'),
                    markerDropped   = false,
                    mapData         = $("#map-data").html(),
                    suggestions = $("#suggestions").html()
            } else {
                var defaultLatLng   = new google.maps.LatLng(52.372863, -1.465852), // default position
                    markerImage     = {
                        url: '/img/template-v2/map-marker.png',
                        scaledSize: new google.maps.Size(35, 43)
                    },
                    personMarkerImage   = {
                        url: '/img/person-marker.png',
                        scaledSize: new google.maps.Size(25, 45)
                    },
                    mapDiv          = document.getElementById('map'),
                    markerDropped   = false,
                    mapData         = $("#map-data").html(),
                    suggestions = $("#suggestions").html()
            }
            
            
            if(position.length >= 1) var defaultLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            
            if(defaultLatLng){
                $("#location-load").hide();
            }
            
            if (mapData.length <= 0 && suggestions == null) {
                if (position.coords) {
                    window.location.href = '/search/auto_detect/'+position.coords.latitude+'/'+position.coords.longitude;
                }
            } else {
                if (mapData.length >= 1) {

                    if ($(window).width() >= 768) {      
                        if ($("body").hasClass('home')) {
                            $("#map").css('height', '480px');
                        } else {
                            $("#map").css('height', '790px');
                        }
                    } else {
                        $("#map").css('height', '400px');
                    }
                    
                    if(auto == null){
                        if(position.coords !== undefined) {
                            var defaultLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                            var mapCenterPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        }
                    } else {
                        var defaultLatLng 	= new google.maps.LatLng(position.lat, position.lng);
                        var moveMap = 0;
                        if ( $( window ).width() >= 1435 ) {
                            moveMap = 0.30;
                        } else if ( $( window ).width() > 1170 ) {
                            moveMap = 0.15;
                        }
                        var mapCenterPosition = new google.maps.LatLng( position.lat, position.lng - moveMap );
                    }
                    
                    if(defaultLatLng){
                        if ($(window).width() >= 768) {                    
                            if ($("body").hasClass('home')) {
                                $("#map").css('height', '480px');
                            } else {
                                $("#map").css('height', '790px');
                            }
                        } else {
                            $("#map").css('height', '400px');
                        }

                        $(".overlay").show();
                        $("#location-load").hide();
                    } else {
                        // no position found at all
                        $("#map").css('height', '0px');
                        $("#location-load").hide();
                        $(".overlay").hide();
                    }
                    
                    var mapStyle = [{"featureType":"all","elementType":"geometry","stylers":[{"invert_lightness":true}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"color":"#000000"},{"lightness":13}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#144b53"},{"lightness":14},{"weight":1.4}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#08304b"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#0c4152"},{"lightness":5}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#0b434f"},{"lightness":25}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#0b3d51"},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"transit","elementType":"all","stylers":[{"color":"#146474"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#021019"}]}];
                    var d = new Date();
                    var n = d.getHours();
                    
                    if (n >= 6 && n < 18) {
                        mapStyle = [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"color":"#d2f1ff"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#004a7e"}]},{"featureType":"administrative.locality","elementType":"labels.text.stroke","stylers":[{"color":"#e3f5fe"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.stroke","stylers":[{"color":"#71a0bb"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ecfaff"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry","stylers":[{"color":"#d3f0ff"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"color":"#f6fdff"}]},{"featureType":"landscape.natural.landcover","elementType":"labels.text","stylers":[{"color":"#bfbfbf"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.fill","stylers":[{"color":"#f8f8f8"}]},{"featureType":"landscape.natural.terrain","elementType":"labels.text","stylers":[{"color":"#c8c8c8"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"labels.text","stylers":[{"color":"#2d87ca"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#98bfdf"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#fdfeff"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#67a3cd"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#69c9ff"},{"visibility":"on"}]}];
                    }
                    
                    var mapOptions = {
                        center: mapCenterPosition,
                        zoom: 11, // The initial zoom level when your map loads (0-20)
                        minZoom: 10, // Minimum zoom level allowed (0-20)
                        maxZoom: 15, // Maximum soom level allowed (0-20)
                        zoomControl:true, // Set to true if using zoomControlOptions below, or false to remove all zoom controls.
                        zoomControlOptions: {
                            style: google.maps.ZoomControlStyle.SMALL,
                            position: google.maps.ControlPosition.RIGHT_CENTER
                        },
                        scrollwheel: false, // Enable Mouse Scroll zooming
                        
                        // All of the below are set to true by default, so simply remove if set to true:
                        panControl:false, // Set to false to disable
                        mapTypeControl:false, // Disable Map/Satellite switch
                        scaleControl:false, // Set to false to hide scale
                        streetViewControl:false, // Set to disable to hide street view
                        overviewMapControl:false, // Set to false to remove overview control
                        rotateControl:false, // Set to false to disable rotate control
                        styles:mapStyle,
                    };
                    
                    map = new google.maps.Map(mapDiv, mapOptions);
                    
                    //Add circle overlay and bind to marker
                    
                    personMarker = new google.maps.Marker({
                        position: defaultLatLng,
                        map: map,
                        animation: google.maps.Animation.DROP,
                        icon: personMarkerImage
                    });
                    
                    if (siteDivID) {
                        var circle = new google.maps.Circle({
                            map: map,
                            radius: 16093,
                            fillColor: '#939393',
                            fillOpacity: 0.15,
                            strokeWeight: 0
                        });
                    } else {
                        var circle = new google.maps.Circle({
                            map: map,
                            radius: 16093,
                            fillColor: '#FFF',
                            fillOpacity: 0.1,
                            strokeWeight: 0
                        });
                    }
                    
                    circle.bindTo('center', personMarker, 'position');
                    
                    $('#map').bind('inview', function(event, visible){
                        if(visible == true && !markerDropped){
                            markerDropped = true;
                            
                            setTimeout(function(){
                                var mapInfoWindow = new google.maps.InfoWindow({
                                    maxWidth: '624px'
                                });
                                
                                $.each(JSON.parse(mapData), function(i, item){
                                    
                                    // window[item.url+'-content'] = new google.maps.InfoWindow({
                                    // 	maxWidth: '624px'
                                    // });
                                    
                                    window[item.url] = new google.maps.Marker({
                                        position: new google.maps.LatLng(item.address_lat, item.address_lng),
                                        map: map,
                                        animation: google.maps.Animation.DROP,
                                        icon: markerImage
                                    });
                                    
                                    window[item.url].addListener('click', function(){
                                        $.get('/view/infowindow/'+item.id, function(data){
                                            mapInfoWindow.setContent(data);
                                            mapInfoWindow.open(map, window[item.url]);
                                        });
                                    });
                                    
                                    google.maps.event.addListener(mapInfoWindow, 'domready', function(){
                                        var iwOuter = $('.gm-style-iw');
                                        var iwBackground = iwOuter.prev();
                                        
                                        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
                                        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
                                        
                                        // Moves the shadow of the arrow 76px to the left margin
                                        iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 15px !important;'});
                                        // Moves the arrow 76px to the left margin
                                        iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 15px !important;'});
                                        iwBackground.children(':nth-child(3)').find('div').children().css({'z-index' : '1'});
                                        var iwCloseBtn = iwOuter.next();
                                        // Apply the desired effect to the close button
                                        iwCloseBtn.css({
                                            opacity: '1', // by default the close button has an opacity of 0.7
                                            right: '-629px',
                                            top: '6px', // button repositioning
                                        });
                                        
                                        // The API automatically applies 0.7 opacity to the button after the mouseout event.
                                        // This function reverses this event to the desired value.
                                        iwCloseBtn.mouseout(function(){
                                            $(this).css({opacity: '1'});
                                        });
                                    });
                                });
                                
                            }, 250);
                        }
                    });
                } else {
                    $("#location-load").hide();
                    $("#map").hide();
                }
            }
        }
        
        this.refereeSignup = function()
        {
            $("select[name=will_travel]").on('change', function(e){
                
                var travelDistance = parseInt($(this).val());
                
                if(travelDistance > 0){
                    
                    $(".distance-results .table, .legal-disclaimer, #oops").hide();
                    $(".distance-results, .distance-results .loading").fadeIn();
                    
                    $.getJSON('/referee/get_signup_venues/'+travelDistance, function(data){
                        $(".distance-results .loading").hide();
                        $(".distance-results .alert-danger").hide();
                        
                        if(data.status == 'ok'){
                            $(".distance-results .table, .legal-disclaimer").show();
                            $(".distance-results .table .venue-row").remove();
                            
                            if(data.results.length >= 1){
                                var mileLabel = $("#mile-label").html();
                                
                                $.each(data.results, function(i,item){
                                    $(".distance-results .table").append('<tr class="venue-row"><td class="text-center"><i class="icon-ll-pitch"></i></td><td>'+item.name+'</td><td width="150" class="text-center">'+item.distance+' ' + mileLabel + '</td></tr>');
                                });
                            } else {
                                $(".distance-results").hide();
                                $("#oops").show();
                                
                            }
                        } else {
                            $(".distance-results .alert-danger").html(data.message).show();
                        }
                    });
                } else {
                    $(".distance-results, .legal-disclaimer").hide();
                }
                
                e.preventDefault();
            });
            
            $("#widen").on('click', function(e){
                
                $("select[name=will_travel]").trigger('click');
                
                e.preventDefault();
            });
        }
        
        this.fixturePay = function()
        {
            if ($("#fixture-pay")) {
                
                var outstandingBalance = parseFloat(0.00);
                
                if ($("input[name=team_balance_visual]")) {
                    outstandingBalance = parseFloat($("input[name=team_balance_visual]").val());
                }
                
                $("input.fixture").on('change', function(){
                    var fixtureId = $(this).data('id'),
                        costEl = $(".total-to-pay span");
                    
                    $(".submit-pay").removeAttr('disabled');
                    
                    if (fixtureId) {
                        var val = $('input.fixture:checkbox:checked').map(function() {
                            return this.value;
                        }).get().join();
                        
                        if (val) {
                            costEl.html('<i class="icon-spin icon-spinner"></i>');
                            
                            $.getJSON('/get/bulkfixturecost/' + val, function (data) {
                                if (data.cost) {
                                    data.cost = parseFloat(data.cost);

                                    if (outstandingBalance > 0 && data.cost < outstandingBalance) {
                                        data.cost = 0;
                                    } else if (outstandingBalance > 0) {
                                        data.cost = data.cost - outstandingBalance;
                                    } else {
                                        data.cost = data.cost + Math.abs(outstandingBalance.toFixed(2));
                                    }
                                    
                                    costEl.html(data.cost.toFixed(2));
                                }
                            });
                        } else {
                            if (outstandingBalance > 0) {
                                costEl.html('0.00');
                            } else {
                                costEl.html(Math.abs(outstandingBalance).toFixed(2));
                            }
                        }
                    }
                });   
            }
        }
        
        this.handleCoord = function()
        {
            $(".submit-results").on('click', function (e) {
                if ($(this).attr('disabled')) {
                    e.preventDefault();
                    alert('Multiple clicks detected');
                    return false;
                } else {
                    $(this).append(' <i class="icon icon-spin fa-spinner"></i>').attr('disabled', true).addClass('disabled');
                    $(".coord-form").submit();
                }
                
                e.preventDefault();
                return false;
            });
            
            $("#disciplinaries").on('change', 'select[name=team_id]', function(e) {
                var teamID = $(this).val();
                var select = $( 'select[name=player_id]' );
                
                // Clear the select options.
                $(".manual-name").addClass('hidden');
                select
                    .find('option')
                    .remove()
                    .end()
                    .append('<option value="" selected>Please Select</option>')
                    .append('<option value="manual">** Player not on system **</option>');
                
                if (players[teamID] !== undefined) {
                    for (var playerID in players[teamID]) {
                        if (!players[teamID].hasOwnProperty(playerID)) continue;
                        
                        select.append('<option value="' + playerID + '">' + players[teamID][playerID] + '</option>');
                    }
                }
                
                e.preventDefault();
            });
            
            $("body").on('change', 'select[name=player_id]', function(e) {
                var val = $(this).val();
                
                if (val == 'manual') {
                    $(".manual-name").removeClass('hidden');
                } else {
                    $(".manual-name").addClass('hidden');
                }
                
                e.preventDefault();
            });
            
            $(".submit-disc").on('click', function(e){
                
                var formData = $(".init-form :input").serialize(),
                    formObj = $("#disc-form");
                
                $(".errors", formObj).hide().html('');
                
                $.post(formObj.data('url'), formData, function(data) {
                    
                    if (data.status == 'error') {
                        $(".errors", formObj).fadeIn(500);
                        
                        $.each(data.errors, function(i,el) {
                            $(".errors", formObj).append(el + '<br />');
                        });
                    } else if(data.status == 'ok') {
                        $(".table tbody", formObj).append(data.rowData);
                        $(".init-form :input").val('');
                        $(".init-form select").val(null);
                        $(".init-form .customSelectInner").html('Please Select');
                        $(".manual-name").addClass('hidden');
                        
                        Leagues.refDisciplinesEnableSubmit();
                    }
                }, "json");
                
                e.preventDefault();
            });
            
            $("body").on('click', ".remove-disc", function(e) {
                
                if (confirm('Are you sure you want to remove this disciplinary action?')) {
                    var rowId = $(this).data('id');
                    
                    $("tr[data-row=" + rowId + "]").remove();
                }
                
                e.preventDefault();
            });
            
            $("body").on('click', ".edit-disc", function(e) {
                
                var rowId = $(this).data('id'),
                    row = $("tr[data-row=" + rowId + "]");
                
                if (row) {
                    var inputs = $(":input", row);
                    
                    if (inputs) {
                        $.each(inputs, function (i, el) {
                            var key = $(el).attr('name').replace("[]", ""),
                                val = $(el).val();
                            
                            $(".init-form input[name=" + key + "], .init-form select[name=" + key + "]").val(val);
                        });
                    }
                }
                
                //$("tr[data-row=" + rowId + "]").remove();
                
                e.preventDefault();
            });
            
            if ( $("body").hasClass("venue") ) {
                Leagues.leagueStatsInfo();
                Leagues.topTablesSlider();
            }
            
            if ( $("body").hasClass("team-profile") ) {
                Leagues.editProfilePencilFocus();
                
                var stats = $( '.player-card .stat, .player-stats .stat' );
                
                if ( stats ) {
                    stats.each( function () {
                        var stat = $(this);
                        var val = stat.data('value');
                        if ( val && val > 0) {
                            var fill = stat.find('.fill');
                            var fillClass = '';
                            if ( val > 70 ) {
                                fillClass = 'green';
                            } else if ( val < 30 ) {
                                fillClass = 'red';
                            } else {
                                fillClass = 'yellow';
                            }
                            fill.addClass(fillClass);
                            fill.width(val+'%');
                        }
                    });
                }
            }
            
            if ( $("body").hasClass("referee") && $("body").hasClass("dashboard") ) {
                Leagues.scoresPopup();
            }
            
            Leagues.loadInitialAmount();
            
            $(".single-amounts").on('keyup', function(e) {
                var total = parseFloat(0);
                
                if (this.value != this.value.replace(/[^0-9\.]/g, '')) {
                    this.value = this.value.replace(/[^0-9\.]/g, '');
                }
                
                $.each( $(".single-amounts"), function(i, el) {
                    // total = total + parseFloat($(el).val());
                    let singleAmount = parseFloat($(el).val());

                    if (!isNaN(singleAmount)) {
                        total = total + singleAmount;
                    }
                });
                
                if (isNaN(total)) {
                    total = 0;
                }
                
                total = total.toFixed(2);

                $("#paid-on-night").html(total);
                Leagues.coordTotal();
                
                e.preventDefault();
            });
            
            $("body").on('click', ".close-overlay", function(e) {
                $(".overlay, .fixture-errors").hide();
                
                e.preventDefault();
            });
            
            $(".team-dna").on('click', function(e) {
                var fixtureId = $(this).data('id'),
                    pointsMatch = $(this).data('points_match'),
                    homeScore = $("input[name=home_team_score_" + fixtureId + "]"),
                    awayScore = $("input[name=away_team_score_" + fixtureId + "]"),
                    homePaid = $("input[name=home_team_paid_amount_" + fixtureId + "]:not([type=hidden])"),
                    awayPaid = $("input[name=away_team_paid_amount_" + fixtureId + "]:not([type=hidden])");
                
                if (fixtureId) {
                    var homeDna = $('input[name=home_team_dna_' + fixtureId + "]").is(":checked"),
                        awayDna = $('input[name=away_team_dna_' + fixtureId + "]").is(":checked");
                    
                    if (homeDna == true && awayDna == false) {
                        homePaid.val(0).trigger('keyup');
                        homeScore.val('0');
                        awayScore.val(pointsMatch);
                    } else if (homeDna == true && awayDna == true) {
                        homePaid.val(0).trigger('keyup');
                        awayPaid.val(0).trigger('keyup');
                        homeScore.val('0');
                        awayScore.val('0');
                    } else if(homeDna == false && awayDna == true) {
                        awayPaid.val(0).trigger('keyup');
                        homeScore.val(pointsMatch);
                        awayScore.val('0');
                    } else if(homeDna == false && awayDna == false) {
                        homeScore.val('');
                        awayScore.val('');
                    }
                }
            });

            $(".ref_transfer_amount").on('focus', function (e) {
                if ($(this).val() == '0.00') {
                    $(this).val('');
                }
            });

            $(".ref_transfer_amount").on('keyup', function (e) {
                var refId = $(this).attr('data-ref-id'),
                    maxPay = parseFloat($("#ref_max_pay_" + refId).text()),
                    paidCash = parseFloat($(this).val()),
                    outstanding = parseFloat((maxPay - paidCash)),
                    paidOnNight = parseFloat($("#paid-on-night").text()),
                    refExpensesTotal = parseFloat(0);
                
                $("input[name=refExpensesPaidTotal]").val(0);                

                // console.log('Cash: ' + paidCash);
                // console.log('Max Pay: ' + maxPay);
                // console.log('Outstanding: ' + outstanding);

                if (paidCash < 0 || isNaN(paidCash) && paidCash > maxPay) {
                    $(this).val('0.00').blur();
                }

                if (maxPay > 0 && !isNaN(outstanding) && outstanding >= 0 && outstanding <= maxPay) {
                    $("#ref_transfer_" + refId).html(outstanding.toFixed(2));
                } else {
                    $(this).val('0.00').blur();
                    $("#ref_transfer_" + refId).html(maxPay.toFixed(2));
                }                
                
                $.each( $(".ref_transfer_amount"), function (i, el) {
                    var refExpense = parseFloat($(el).val());

                    if (refExpense >= 0 && !isNaN(refExpense)) {
                        refExpensesTotal = refExpensesTotal + refExpense;
                    }
                });

                if (paidOnNight < refExpensesTotal) {
                    $(".ref_transfer_amount").val('0.00').blur();
                    alert('Paid in cash amount is more than cash payments. Please try again.');
                } else {
                    $("input[name=refExpensesPaidTotal]").val(paidOnNight - refExpensesTotal);
                }

                Leagues.coordTotal();
            });
        };
        
        this.topTablesSlider = function ()
        {
            var top5tableSlider = $('.hasTopScores .top5');
            var fairestTableSlider = $('.hasTopScores .fairestTeam');
            
            top5tableSlider.slick({
                draggable: false,
                dots: false,
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                autoplay: false
            });
            
            fairestTableSlider.slick({
                draggable: false,
                dots: false,
                arrows: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                autoplay: false
            });
            
            var top5Prev = top5tableSlider.find( 'button.slick-prev' );
            var fairestPrev = fairestTableSlider.find( 'button.slick-prev' );
            var top5Next = top5tableSlider.find( 'button.slick-next' );
            var fairestNext = fairestTableSlider.find( 'button.slick-next' );
            
            top5Next.on( 'click', function () {
                fairestNext.trigger( 'click' );
            } );
            
            fairestNext.on( 'click', function () {
                top5Next.trigger( 'click' );
            } );
            
            top5Prev.on( 'click', function () {
                fairestPrev.trigger( 'click' );
            } );
            
            fairestPrev.on( 'click', function () {
                top5Prev.trigger( 'click' );
            } );
        };
        
        this.leagueStatsInfo = function ()
        {
            var rowToggler = $('.hasToggle');
            rowToggler.each( function () {
                var row = $(this);
                
                if ( row[0].classList.contains( 'desktop' ) ) {
                    var fixtureDate = $( row, '.desktop' ).data('date');
                    $( '.fixture-set .league-table thead.' + fixtureDate + ' .fixture-date' ).addClass( 'hasInfo' );
                }
                
                
                $( 'i', this ).on( 'click', function () {
                    $('+ tr', row ).toggle();
                    row.toggleClass( 'closed' );
                } );
            });
            
            var tooltips = $('.stat-tooltip');
            tooltips.each(function () {
                var tooltip = $(this);
                
                if (!tooltip.data('tooltip-id')) {
                    var id = Math.floor(Math.random() * 2000000);
                    var stats = tooltip.data('stats');
                    var title = tooltip.data('title');
                    var lis = '';
                    
                    Object.values(stats).forEach( function (stat) {
                        lis += '<li><div class="name">' + stat.name + '</div><div class="scores">';
                        if ( null !== stat.y_card ) {
                            lis += '<img class="card yellow" src="/img/yellow-card.png" alt="Yellow Card">';
                        }
                        if ( null !== stat.r_card ) {
                            lis += '<img class="card red" src="/img/red-card.png" alt="Red Card">';
                        }
                        if ( null !== stat.goals ) {
                            var i;
                            for ( i = 0; i < stat.goals; i++ ) {
                                lis += '<img class="card goal" src="/img/goal.png" alt="Goals">';
                            }
                        }
                        lis += '</div></li>';
                    } );
                    
                    var html = '<div class="stat-box">' +
                        '<div class="head">' + title + '</div>' +
                        '<div class="body">' +
                        '<ul>' +
                        lis +
                        '</ul>' +
                        '   </div>' +
                        '</div>';
                    
                    tooltip.data('tooltip-id', id);
                    tooltip.append(html);
                }
            });
        };
        
        this.editProfilePencilFocus = function()
        {
            $("body").on('click', '#edit-profile-form-row .icon-pencil', function(e) {
                $(this).parent().parent().find('input').focus();
            });
        };
        
        this.scoresPopup = function ()
        {
            var scoresPopup = $( '#scoresPopup' );
            var errorBlock = $(".errors", scoresPopup);
            var successMsg = $(".success-msg", scoresPopup);
            var playerAdded = $(".player-added", scoresPopup);
            var saveBtn = $( '.save-scores', scoresPopup );
            var formObj = null;
            var teamName = null;
            var teamID = null;
            var fixtureID = null;
            var leagueID = null;
            var divisionID = null;
            var addPlayer = $( '#add-tmp-player' );
            var addPlayerInput = addPlayer.find( 'input' );
            var addPlayerBtn = addPlayer.find( 'button' );
            var scoresBody = $( '.modal-body .players-table', scoresPopup );
            
            function hideAlerts () {
                errorBlock.hide().html('');
                successMsg.hide();
                playerAdded.hide();
            }
            
            $("body").on('click', '.edit-stats', function(e) {
                var teamPlayersIds = [];
                var playersTmpIds = [];
                var allTeamPlayers = [];
                
                hideAlerts();
                
                formObj = $(this);
                teamName = formObj.data('team-name');
                teamID = formObj.data('team-id');
                leagueID = formObj.data('league-id');
                divisionID = formObj.data('division-id');
                fixtureID = formObj.data('fixture-id');
                
                function showScoresPopup () {
                    scoresPopup.modal( {
                        show: true,
                        backdrop: 'static',
                        keyboard: false
                    } );
                }
                function showErrorInScoresPopup () {
                    $( '.modal-footer .save-scores', scoresPopup ).hide();
                    $( '.modal-body', scoresPopup ).html( '<div class="no-data">Connection error...</div>' );
                }
                
                scoresPopup.on('hidden.bs.modal', function (e) {
                    scoresBody.html('');
                    errorBlock.hide().html('');
                    successMsg.hide();
                    addPlayerInput.val('');
                    // if (!data) return e.preventDefault() // stops modal from being shown
                });
                
                $( '.modal-header .team-name', scoresPopup ).text( teamName );
                
                if (players[teamID] !== undefined) {
                    for (var playerID in players[teamID]) {
                        if (!players[teamID].hasOwnProperty(playerID)) continue;
                        
                        teamPlayersIds.push( playerID );
                        allTeamPlayers.push( {
                            team_id: teamID,
                            player_id: parseInt(playerID),
                            tmp_player_id: null,
                            name: players[teamID][playerID],
                            registered: true,
                            y_card: '',
                            r_card: '',
                            goals: ''
                        } );
                    }
                }
                
                if (playersTmp[teamID] !== undefined) {
                    for (var playerTmpID in playersTmp[teamID]) {
                        if (!playersTmp[teamID].hasOwnProperty(playerTmpID)) continue;
                        
                        playersTmpIds.push( playerTmpID );
                        allTeamPlayers.push( {
                            team_id: teamID,
                            player_id: null,
                            tmp_player_id: parseInt(playerTmpID),
                            name: playersTmp[teamID][playerTmpID],
                            registered: false,
                            y_card: '',
                            r_card: '',
                            goals: ''
                        } );
                    }
                }
                
                $.post( formObj.data('url'), { _token: $('input[name="_token"]').first().val(), teamPlayersIds: teamPlayersIds, playersTmpIds: playersTmpIds, fixtureID: fixtureID }, "json").done( function(data) {
                    if (data.status !== 'success') {
                        showErrorInScoresPopup();
                    } else {
                        if ( data.teamStats.length > 0 ) {
                            Object.values( data.teamStats ).forEach( function ( stat ) {
                                Object.keys( allTeamPlayers ).forEach( function ( i ) {
                                    if ( ( stat.player_id === allTeamPlayers[ i ].player_id && null !== stat.player_id ) ||
                                        ( stat.tmp_player_id === allTeamPlayers[ i ].tmp_player_id && null !== stat.tmp_player_id )
                                    ) {
                                        allTeamPlayers[ i ].y_card = ( stat.y_card === 1 ) ? 'checked' : '';
                                        allTeamPlayers[ i ].r_card = ( stat.r_card === 1 ) ? 'checked' : '';
                                        allTeamPlayers[ i ].goals = ( stat.goals === undefined || stat.goals === null ) ? '' : stat.goals;
                                    }
                                } );
                            } );
                        }
                        
                        var html = '';
                        Object.values( allTeamPlayers ).forEach( function ( player ) {
                            html += '<tr>\n' +
                                '   <input type="hidden" name="registered" value="' + player.registered + '">' +
                                '   <input type="hidden" name="player_name" value="' + player.name + '">' +
                                '   <input type="hidden" name="player_id" value="' + player.player_id + '">' +
                                '   <input type="hidden" name="tmp_player_id" value="' + player.tmp_player_id + '">' +
                                '   <td><div class="name">' + player.name + '</div></td>\n' +
                                '   <td width="80" class="text-center darker"><div class="y_card checkbox_wrap"><input name="y_card" type="checkbox" ' + player.y_card + '><span class="checkmark"></span></div></td>\n' +
                                '   <td width="80" class="text-center"><div class="r_card checkbox_wrap"><input name="r_card" type="checkbox" ' + player.r_card + '><span class="checkmark"></span></div></td>\n' +
                                '   <td width="100" class="text-center darker"><div class="goals"><input class="form-control single-amounts dark" name="goals" type="number" value="' + player.goals + '" min="0"></div></td>\n' +
                                '</tr>\n';
                        } );
                        scoresBody.append( html );
                    }
                    
                    $( ':input', scoresBody ).on( 'change', function () {
                        saveBtn.prop( 'disabled', false );
                    } );
                    
                    showScoresPopup();
                }).fail( function() {
                    showErrorInScoresPopup();
                    showScoresPopup();
                });
                
                addPlayerInput.on( 'keyup', function () {
                    if ( $(this).val().length >= 3 ) {
                        addPlayerBtn.prop( 'disabled', false );
                    } else {
                        addPlayerBtn.prop( 'disabled', true );
                    }
                } );
                
                e.preventDefault();
            });
            
            var addPlayerBtnCount = 0;
            addPlayerBtn.on( 'click', function () {
                if ( addPlayerBtnCount !== 0 ) {
                    console.log( 'double click?' );
                    return false;
                }
                addPlayerBtnCount++;
                hideAlerts();
                var newPlayer = addPlayerInput.val().trim();
                var nameRegex = /^[a-zA-Z'. ]+$/i;
                
                if ( 3 > newPlayer.length ) {
                    errorBlock.fadeIn(500);
                    addPlayerBtnCount = 0;
                    return errorBlock.append( 'Minimum 3 characters' );
                }
                // return console.log( nameRegex.test( newPlayer ) );
                if ( ! nameRegex.test( newPlayer ) ) {
                    errorBlock.fadeIn(500);
                    addPlayerBtnCount = 0;
                    return errorBlock.append( 'Must be a valid name' );
                }
                
                $.post( '/referee/addTempPlayer/' + teamID , { _token: $('input[name="_token"]').first().val(), newPlayer: newPlayer }, function(data) {
                    if ( 'success' === data.status ) {
                        var playerHtml = '<tr>\n' +
                            '   <input type="hidden" name="registered" value="false">' +
                            '   <input type="hidden" name="player_name" value="' + newPlayer + '">' +
                            '   <input type="hidden" name="player_id">' +
                            '   <input type="hidden" name="tmp_player_id" value="' + data.pid + '">' +
                            '   <td><div class="name">' + newPlayer + '</div></td>\n' +
                            '   <td width="80" class="text-center darker"><div class="y_card checkbox_wrap"><input name="y_card" type="checkbox"><span class="checkmark"></span></div></td>\n' +
                            '   <td width="80" class="text-center"><div class="r_card checkbox_wrap"><input name="r_card" type="checkbox"><span class="checkmark"></span></div></td>\n' +
                            '   <td width="100" class="text-center darker"><div class="goals"><input class="form-control single-amounts dark" name="goals" type="number" value="" min="0"></div></td>\n' +
                            '</tr>\n';
                        scoresBody.append( playerHtml );
                        
                        if ( 'undefined' === typeof playersTmp[teamID] ) {
                            playersTmp[teamID] = {};
                        }
                        
                        playersTmp[teamID][data.pid] = newPlayer;
                        playerAdded.fadeIn(500);
                        
                        $( ':input', scoresBody ).on( 'change', function () {
                            saveBtn.prop( 'disabled', false );
                        } );
                    } else {
                        errorBlock.fadeIn(500);
                        errorBlock.append( 'Unable to save a new player' );
                    }
                }, "json");
                
                addPlayerBtn.prop( 'disabled', true );
                addPlayerInput.val('');
                addPlayerBtnCount = 0;
            } );
            
            saveBtn.on( 'click', function (e) {
                var playerRows = $( '.modal-body .players-table tr', scoresPopup );
                var playersData = [];
                
                hideAlerts();
                
                playerRows.each( function ( i ) {
                    playersData.push( {
                        registered: $( 'input[name=registered]', this ).val(),
                        player_name: $( 'input[name=player_name]', this ).val(),
                        player_id: $( 'input[name=player_id]', this ).val(),
                        tmp_player_id: $( 'input[name=tmp_player_id]', this ).val(),
                        y_card: $( 'input[name=y_card]', this ).prop("checked") === true ? 1 : null,
                        r_card: $( 'input[name=r_card]', this ).prop("checked") === true ? 1 : null,
                        goals: $( 'input[name=goals]', this ).val(),
                    } );
                } );
                // saveFixtureTeamScores
                $.post( '/referee/saveFixtureTeamScores/' + leagueID + '/' + divisionID + '/' + fixtureID + '/' + teamID , { _token: $('input[name="_token"]').first().val(), playersData: playersData }, function(data) {
                    if ( data.status === 'error' ) {
                        errorBlock.fadeIn(500);
                        $.each(data.errors, function(i,el) {
                            errorBlock.append(el + '<br />');
                        });
                    } else if ( data.status === 'success' ) {
                        successMsg.fadeIn(500);
                    }
                    
                    saveBtn.prop( 'disabled', true );
                }, "json");
            } );
        };
        
        this.loadInitialAmount = function()
        {
            if (!$("#paid-on-night").hasClass('set')) {
                var total = 0;
                
                $.each( $(".single-amounts"), function(i, el) {
                    
                    if (!isNaN($(el).val()) && $(el).val() > 0) {
                        total = total + parseFloat($(el).val());
                    }
                });
                
                if (isNaN(total)) {
                    total = 0;
                }
                
                total = total.toFixed(2);
                
                $("#paid-on-night").html(total);
            }
            
            Leagues.coordTotal();
        };
        
        this.coordTotal = function()
        {
            var paid = parseFloat($("#paid-on-night").html()),
                refExpenses = parseFloat($("#ref-expenses").html()),
                bankTotal = parseFloat(paid - refExpenses).toFixed(2),
                excludedCentreCost = $('#excludedCentreCost'),
                refExpensesPaidRemaining = parseFloat($("input[name=refExpensesPaidTotal]").val()),
                refExpensesPaidSoFar = parseFloat(0);

            if ( 1 === excludedCentreCost.length ) {
                var centreCost = excludedCentreCost.data('cost');
                
                bankTotal = parseFloat( bankTotal - centreCost ).toFixed(2);
            }

            if (bankTotal < 0) {
                $("#ref-expenses-detail").css('display', 'block');
            } else if(bankTotal > 0) {
                $("#ref-expenses-detail").css('display', 'none');
                $("input[name=refExpensesPaidTotal]").val('0.00');
                $(".canPayExpenses input").val('');
            }

            if (paid > 0) {
                $(".canPayExpenses").show();
                $(".cantPayExpenses").hide();
            } else {
                $(".cantPayExpenses").show();
                $(".canPayExpenses").hide();
                $(".canPayExpenses input").val('');
            }

            $.each( $(".canPayExpenses input"), function (i, el) {
                refExpensesPaidSoFar = refExpensesPaidSoFar + parseFloat($(el).val());
            });            

            if (bankTotal < 0) {
                bankTotal = parseFloat(0);
            }

            // console.log('paid: ' + paid);
            // console.log('refExpenses: ' + refExpenses);
            // console.log('refExpensesPaidRemaining: ' + refExpensesPaidRemaining);
            // console.log('refExpensesPaidSoFar: ' + refExpensesPaidSoFar);
            // console.log('bankTotal: ' + bankTotal);
            // console.log('-----------------------');
            
            if (paid > 0 && paid - refExpenses < 0) {
                if (refExpensesPaidSoFar > 0) {
                    // there isnt enough to pay the refs fully
                    if (refExpensesPaidSoFar == paid) {
                        //console.log('all cash used up');
                        bankTotal = parseFloat(0).toFixed(2);
                    } else {
                        //console.log('pay outstanding cash in');
                        bankTotal = parseFloat(refExpensesPaidRemaining).toFixed(2)
                    }
                } else {
                   // console.log('fall back');
                    bankTotal = parseFloat(paid).toFixed(2);
                }
            }
            
            $("#bank-total").html(bankTotal);
        };
        
        this.animateJoinUs = function()
        {
            if($(window).width() >= 768){
                
                var iconsVisible = false;
                $(".join-box").hide();
                $("#join-us .text-center").css('top', '-350px');
                
                $(".join-icons").bind('inview', function(event, visible){
                    
                    if(visible == true && !iconsVisible){
                        iconsVisible = true;
                        
                        $("#join-us .text-center").stop().animate({
                            top: 0
                        }, 500, function(){
                            $(".join-box").animateOrder('fade', 300);
                        });
                    }
                });
            }
        }
        
        
        this.ourStory = function()
        {
            if ($('body').hasClass('about-us')) {
                var $ball = $('.the-ball');
                var bounceSpeed = 750;
                var bounceAmount = 2;
                var goalVisible = false;
                var iconsVisible = false;
                var initialBallOffset = parseInt($ball.offset().top);
                var $firstMarker = $('.timeline').first();
                // var bounceButton = function () {
                //     $('#our-story .btn').effect('bounce', {
                //         times: bounceAmount,
                //     }, bounceSpeed);
                // };
                
                // bounceButton();
                // setInterval(bounceButton, 3000);
                Leagues.animateKeeper();
                
                $(window).scroll(function () {
                    // Move the Ball as required.
                    var scrollPos = $(document).scrollTop();
                    
                    if (scrollPos >= (initialBallOffset / 2)) {
                        $ball.css('position', 'fixed');
                    } else {
                        $ball.css('position', 'absolute');
                    }
                    
                    var ballPos = $ball.offset().top;
                    
                    // Animate Ball as scrolled.
                    $ball.addClass('animated');
                    clearTimeout($.data(this, 'scrollTimer'));
                    $.data(this, 'scrollTimer', setTimeout(function () {
                        $ball.one('animationiteration webkitAnimationIteration', function () {
                            $(this).removeClass('animated').show();
                        });
                    }, 100));
                    
                    // Make the Ball smaller as it hits the first marker.
                    if (ballPos >= $firstMarker.offset().top && !$ball.hasClass('scoring')) {
                        $ball.addClass('scoring');
                    } else if (ballPos < $firstMarker.offset().top && $ball.hasClass('scoring')) {
                        $ball.removeClass('scoring').show();
                    }
                    
                    // Animate the individual timelines when they come in to view.
                    $('.timeline').each(function () {
                        var $timeline = $(this);
                        var timelineTop = $timeline.offset().top;
                        
                        if (ballPos >= timelineTop && !$timeline.hasClass('timeline--in-view')) {
                            $timeline.addClass('timeline--in-view');
                        }
                    });
                    
                    $('#goal').bind('inview', function (event, visible){
                        if (visible && !iconsVisible) {
                            $('.story-icon').animateOrder('fade', 500);
                            
                            iconsVisible = true;
                            
                            setTimeout(function () {
                                var options = {
                                    useEasing: true,
                                    useGrouping: true,
                                    separator: ',',
                                    decimal: '.',
                                    prefix: '',
                                    suffix: '',
                                };
                                
                                var playersPlaying = new CountUp('players-playing', 0, 63000, 0, 3, options);
                                playersPlaying.start();
                                
                                var gamesPlayed = new CountUp('games-played', 0, 184000, 0, 3, options);
                                gamesPlayed.start();
                                
                                var sweatyBallsacks = new CountUp('sweaty-ballsacks', 0, 26000, 0, 3, options);
                                sweatyBallsacks.start();
                            }, 1500);
                        }
                    });
                    
                    $('footer').bind('inview', function (event, visible) {
                        if (visible) {
                            $ball.hide();
                        } else {
                            $ball.show();
                        }
                    });
                });
            }
        }
        
        this.animateKeeper = function()
        {
            startKeeper();
            
            function startKeeper()
            {
                $("#keeper").stop(true, true).animate({
                    left: '890px'
                }, 4000, function(){
                    resetKeeper();
                });
            }
            
            function resetKeeper()
            {
                $("#keeper").stop(true, true).animate({
                    left: '0px'
                }, 4000, function(){
                    startKeeper();
                });
            }
        }
        
        
        this.siteBanners = function()
        {
            var bannerOuter = $("#banner-outer"),
                firstSlide 	= $(".banner-item:first"),
                firstButton = $(".banner-pagination li:first"),
                origState 	= [];
            
            if (bannerOuter) {
                $(".banner-item").hide();
                $(".supporting-image").hide();
                $(".supporting-text").hide();
                
                $.each($(".banner-item"), function(i,el) {
                    var clone = $(el).clone();
                    origState[clone.data('id')] = clone;
                });
                
                Leagues.loadBanner($("a", firstButton).data('id'));
                
                $(".banner-pagination a").on('click', function(e) {
                    Leagues.loadBanner($(this).data('id'), $(this).data('iteration'));
                    e.preventDefault();
                });
            }
        }
        
        this.loadBanner = function(id, queue)
        {
            var banner 		= $(".banner-item[data-id="+id+"]"),
                animType 	= banner.data('anim-type'),
                animSpeed 	= banner.data('anim-speed'),
                slideTime   = banner.data('slider-time');
            
            queue = queue == null ? 1 : queue;
            if ( 'undefined' === typeof slideTime ) slideTime = 9000;
            
            clearTimeout(bannerSlideTimer);
            
            if (banner.length >= 1) {
                $(".banner-item").removeClass('active').hide();
                $(".banner-pagination a").removeClass('active');
                $(".supporting-image").hide();
                $(".supporting-text").hide();
                
                $(".banner-pagination a[data-id="+id+"]").addClass('active');
                banner.addClass('active');
                
                //reset the old banner back to previous state....
                if (animType == 'fade') {
                    
                    $(".supporting-image, .supporting-text", banner).hide();
                    
                    banner.fadeIn(500, function() {
                        $(".supporting-image", banner).fadeIn(animSpeed, function() {
                            $(".supporting-text", banner).fadeIn(animSpeed);
                        });
                    });
                } else if (animType == 'slide-up') {
                    $(".supporting-image, .supporting-text", banner).css('top', '1250px');
                    
                    banner.fadeIn(500, function() {
                        $(".supporting-image", banner).show().stop(true,true).animate({
                            top: '0px'
                        }, animSpeed, function(){
                            $(".supporting-text", banner).show().stop(true,true).animate({
                                top: '0px'
                            }, animSpeed);
                        });
                    });
                } else if (animType == 'slide-down') {
                    $(".supporting-image, .supporting-text", banner).css('top', '-1250px');
                    
                    banner.fadeIn(500, function() {
                        $(".supporting-image", banner).show().stop(true,true).animate({
                            top: '0px'
                        }, animSpeed, function(){
                            $(".supporting-text", banner).show().stop(true,true).animate({
                                top: '0px'
                            }, animSpeed);
                        });
                    });
                }
            }
            
            var banners = $('.banner-pagination li').length;
            bannerSlideTimer = setTimeout(function() {
                queue = queue + 1 > banners ? 1 : ++queue;
                Leagues.loadBanner($('.banner-pagination li:nth-child(' + queue + ') a').data('id'), queue);
            }, slideTime);
        }
        
        this.readMore = function()
        {
            var originalHeight = $(".read-more").outerHeight();
            $(".read-more").attr('data-h', originalHeight).css('height', '115px');
            
            $(".read-more-button").on('click', function(e){
                
                var readMore = $(".read-more");
                
                if (readMore.outerHeight() <= 115) {
                    readMore.stop(true).animate({
                        height: originalHeight + 'px'
                    }, 1000);
                    
                    $(".read-more-button").html('Read Less');
                } else {
                    readMore.stop(true).animate({
                        height: '115px'
                    }, 1000);
                    
                    $(".read-more-button").html('Read More');
                }
                
                e.preventDefault();
            });
        }
        
        /** Check disciplines and not allow submit results form when disciplinary is not submit. */
        this.refDisciplines = function()
        {
            $( "select, textarea", "#disc-form" ).on( 'change keyup paste', function () {
                Leagues.refDisciplinesCheckInputs();
            } );
        };
        
        this.refDisciplinesCheckInputs = function()
        {
            // Indicates if any of the inputs was changed.
            var changed = false;
            
            // Find inputs in the form.
            const inputs = $( "select, textarea", "#disc-form" );
            
            // Check all inputs if any of them changed.
            inputs.each( function() {
                changed = $( this ).val() != '' || changed;
            } );
            
            if ( changed ) {
                Leagues.refDisciplinesDisableSubmit();
            } else {
                Leagues.refDisciplinesEnableSubmit();
            }
        };
        
        this.refDisciplinesDisableSubmit = function()
        {
            var submitButton =  $( ".submit-results" );
            
            if ( !$( ".disciplinaries-warning" ).length ) {
                var message = '<div class="alert alert-warning disciplinaries-warning" role="alert">' + disciplinesMessage + '</div>';
                submitButton.after( message );
            }
            submitButton.addClass( 'hidden' );
        };
        
        this.refDisciplinesEnableSubmit = function()
        {
            $( ".disciplinaries-warning" ).remove();
            $( ".submit-results" ).removeClass( 'hidden' );
        };
    }
    
    Leagues.init();
    
});
